import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import Detail from './Detail';
import Header from '../../../../../../shared/library/Header/Header';
import './css/Details.styl';

export class Details extends Component {
  render() {
    const {details} = this.props;
    const hasAnyValidDetails = details
      ? details.filter(detail => !detail.value.toLowerCase().includes('n/a'))
          .length > 0
      : false;

    const detailItems = details
      ? details.map((detail, i) => <Detail key={i} detail={detail} />)
      : null;

    return this.props.planning || hasAnyValidDetails ? (
      <div className="details">
        <Header title="Details" />
        <ul className="details__unordered-list">{detailItems}</ul>
      </div>
    ) : null;
  }
}

Details.propTypes = {
  details: PropTypes.array.isRequired,
  planning: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  planning: state.planningStore.isPlanning,
});

export default connect(mapStateToProps)(Details);



// WEBPACK FOOTER //
// ./src/reactModules/pages/Profile/components/Tabs/AboutUs/Details/index.js